<template>
  <div>
    <div class="c-file">
      <lego-text-field readonly :value="value && value.name" />
      <div class="file-select">
        <lego-button border primary @click="handleBtnClick">{{
          this.t('button.attachFile')
        }}</lego-button>
        <input ref="fileBox" type="file" @change="handleFileChange" />
      </div>
    </div>
    <div class="c-file-message">{{ errorMessage || message }}</div>
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin.js';

// const BYTE_TO_MB = 1024 * 1024;

export default {
  name: 'cFile',
  mixins: [i18nMixin],
  props: {
    value: {
      type: File,
      default: () => {},
    },
    message: {
      type: String,
      default: '',
    },
    // fileSizeLimit: {
    //   type: [String, Number],
    //   default: 10,
    // },
  },
  data() {
    return {
      errorMessage: '',
    };
  },
  methods: {
    handleBtnClick() {
      this.$refs.fileBox.click();
    },
    handleFileChange(e) {
      this.$emit('input', e.target.files[0]);
    },
    // getMaxFileSize() {
    //   if (!this.fileSizeLimit || parseInt(this.fileSizeLimit) === -1) {
    //     return 1024 * 1024 * BYTE_TO_MB;
    //   } else {
    //     return parseInt(this.fileSizeLimit) * BYTE_TO_MB;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.c-file {
  display: flex;
  align-items: center;
  position: relative;
  .file-select {
    cursor: pointer;
    > .lego-button {
      margin-left: 8px;
      width: 100px;
    }
    > input[type='file'] {
      display: none;
    }
  }
}
.c-file-message {
  color: $color--status--error;
  @include font(12px);
}
</style>
